// THIS SCRIPT IS GENERIC
// As Philipe advise, this should be moved to a JS file
// It works with AbTests::GenericHelper#ab_test_tag as a setup
function startABTest(test, scenario) {
  var activables = $('.ABTest-' + test + '-' + scenario);
  activables.each(function() {
    $(this).removeClass('ABTest-hidden')
    var data = $(this).data('ab-test-class-' + scenario);
    $(this).addClass(data);
    $(this).trigger('ABTestStart');
  })
};

// This allow to set on the test using params
document.addEventListener("DOMContentLoaded", function(event){
  // Handle params
  var url = new URL(window.location.href)
  var search = new URLSearchParams(url.search);
  // FIXME Params "page" is confusing, it has no relation with the page
  var test = search.get('page');
  var scenario = search.get('highlight');
  if (test && scenario) {
    startABTest(test, scenario);
  }
});

export {
  startABTest
}
